/**
 * Enum for custom http request/response headers.
 * @readonly
 * @enum {string}
 */
const HttpHeaders = Object.freeze({
    PJax: 'x-pjax',
    PJaxTitle: 'x-pjax-title',
    PJaxDescription: 'x-pjax-description',
    PJaxPushUrl: 'x-pjax-push-url',
    PJaxRefresh: 'x-pjax-refresh',
    PJaxVersion: 'x-pjax-version',
    RequestedWith: 'x-requested-with',
    ContentType: 'Content-Type',
});

export default HttpHeaders;
